export default __webpack_public_path__ + "static/media/logo-tdx.51a41c80.svg";